// extracted by mini-css-extract-plugin
export var closeButton = "_lr-1";
export var closeX = "_lr-3";
export var container = "_lr-0";
export var image = "_lr-2";